import { useEffect } from 'react';
import { CATALOGO } from '@/constants/catalogo';
import { fmt } from '@/lib/utils';

export default function CfgIdentidad({ producto, onUpdate }) {
  const catalogo = CATALOGO.identidad;
  const cfg = producto.config || { variante: 'completa', addons: {} };

  const recalc = (newCfg) => {
    const v = catalogo.variantes.find((va) => va.id === newCfg.variante);
    const addonsT = Object.entries(newCfg.addons).reduce(
      (s, [k, val]) => s + (val ? catalogo.addons[k].precio : 0),
      0
    );
    onUpdate({ config: newCfg, precioFinal: (v?.precio || 0) + addonsT });
  };

  useEffect(() => {
    if (!producto.configurado) recalc(cfg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-3 gap-2">
        {catalogo.variantes.map((v) => (
          <button
            key={v.id}
            onClick={() => recalc({ ...cfg, variante: v.id })}
            className={`p-3 rounded-lg border text-left ${
              cfg.variante === v.id
                ? 'border-brand-gold bg-brand-gold/10'
                : 'border-neutral-800 bg-neutral-900/50'
            }`}
          >
            <div className="text-white text-xs mb-1">{v.label}</div>
            <div className="text-brand-gold text-xs font-medium">{fmt(v.precio)}</div>
          </button>
        ))}
      </div>
      <div>
        <div className="text-xs text-neutral-400 uppercase tracking-wider mb-2">
          Complementos
        </div>
        <div className="space-y-1.5">
          {Object.entries(catalogo.addons).map(([k, a]) => (
            <label
              key={k}
              className="flex items-center justify-between p-2 bg-neutral-900/50 border border-neutral-800 rounded cursor-pointer"
            >
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={cfg.addons[k] || false}
                  onChange={(e) =>
                    recalc({ ...cfg, addons: { ...cfg.addons, [k]: e.target.checked } })
                  }
                  className="accent-brand-gold"
                />
                <span className="text-white text-xs">{a.label}</span>
              </div>
              <span className="text-brand-gold text-xs">+{fmt(a.precio)}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
